import { ModelError_Response } from '@treadinc/horizon-api-spec';
import { isAxiosError } from 'axios';

import { extractFieldErrors } from '~utils/extractAxiosError';
import { PayCommissionParty } from '~utils/jobs/job-utils';

// Override refusals name the pricing-level field even when the `_pay_` key was sent.
const commissionPartyByApiField: Record<string, PayCommissionParty> = {
  driver_commission_percentage: 'driver',
  driver_pay_commission_percentage: 'driver',
  vendor_commission_percentage: 'vendor',
  vendor_pay_commission_percentage: 'vendor',
};

export function payCommissionFieldError(error: unknown, party: PayCommissionParty) {
  if (!isAxiosError<ModelError_Response>(error) || error.response?.status !== 422) {
    return undefined;
  }

  return extractFieldErrors(error).find(
    ({ field }) => commissionPartyByApiField[field] === party,
  )?.message;
}
